<template>
  <keep-alive>
    <Mobile
      :doctor-groups="doctorGroups"
      :year="year"
    />
  </keep-alive>
</template>

<script setup lang="ts">
import type { IDoctorGroup } from '~/types'
import Mobile from '~/features/doctors/Mobile.vue'
import DoctorsApi from '~/features/doctors/api/doctors'
import { AWARD_ROUTE_NAMES } from '~/features/Home/constants'

const $route = useRoute()
const mainStore = useMainStore()

const title = `Всероссийская премия ПроДокторов ${$route.params.year} - врачи в ${mainStore.region?.prepositional_form}`
const description = `Лучшие врачи в ${mainStore.region?.prepositional_form} по отзывам за ${$route.params.year} год`

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogUrl: useRuntimeConfig().public.awardUrl + $route.fullPath,
})

const year = computed(() => Number($route.params.year))
const city = computed(() => $route.params.city as string)
const doctorGroups = computed<IDoctorGroup[]>(() => mainStore.doctorGroups[city.value + year.value])

const { error } = await useAsyncData(
  $route.path,
  async () => {
    if (year.value === mainStore.awardYear && mainStore.awardState === 'announcement') {
      return navigateTo({
        name: AWARD_ROUTE_NAMES.main,
        params: { year: year.value },
      })
    }

    // Если в сторе нет загруженных врачей -> загружаем и записываем в стор
    if (!doctorGroups.value) {
      const api = new DoctorsApi({ year: Number(year.value), region: city.value })

      if (mainStore.isFeatureFlagEnabled('replace_year_for_query_param')) {
        mainStore.doctorGroups[city.value + year.value] = (await api.getData()).filter(g => g.doctors.length)
      } else {
        mainStore.doctorGroups[city.value + year.value] = (await api.get()).filter(g => g.doctors.length)
      }
    }
  })

if (error.value) {
  showError(error.value)
}
</script>
